import { PaginatedResponse } from '@gorila-shared-ui/components';
import { Position } from 'geojson';
import { atom, atomFamily, selector, selectorFamily } from 'recoil';
import { Link, LinkDetail } from '../types/link';

export const loadingLinksState = atom({
  key: 'app.client.links.loading',
  default: false,
});

export const linksState = atom<PaginatedResponse<Link> | undefined>({
  key: 'app.client.links',
  default: undefined,
});

export const searchLinkState = atom<string | undefined>({
  key: 'app.client.links.search',
  default: undefined,
});

export const linksPageState = atom({
  key: 'app.client.links.page',
  default: 1,
});

export const selectedLinkIdState = atom<string | undefined>({
  key: 'app.client.links.selectedId',
  default: undefined,
});

export const selectedLinkState = selector({
  key: 'app.client.links.selected',
  get: ({ get }) => {
    const selectedLinkId = get(selectedLinkIdState);
    if (!selectedLinkId) return;
    return get(linkState(selectedLinkId));
  },
});

export const linkState = selectorFamily<Link | undefined, string>({
  key: 'app.client.link',
  get:
    (id) =>
    ({ get }) => {
      const links = get(linksState);
      if (!links) return;
      return links.items.find((link) => link._id === id);
    },
});

export const linkDetailState = atomFamily<LinkDetail | undefined, string>({
  key: 'app.client.link.detail',
  default: undefined,
});

export const linkDetailLngLatsState = selectorFamily<Position[], string>({
  key: 'app.client.link.detail.lnglats',
  get:
    (id) =>
    ({ get }) => {
      const selectedLinkId = get(selectedLinkIdState);
      if (!selectedLinkId) return [];
      const linkDetail = get(linkDetailState(selectedLinkId));
      if (!linkDetail) return [];
      return [
        [linkDetail.assetPrimary.position_longitude, linkDetail.assetPrimary.position_latitude],
        [linkDetail.assetSecondary.position_longitude, linkDetail.assetSecondary.position_latitude],
      ];
    },
});

export const linkIdsState = selector<string[] | undefined>({
  key: 'app.client.linkIds.filtered',
  get: ({ get }) => {
    const links = get(linksState);
    if (!links) return;

    return links.items.map((link) => link._id);
  },
});
